var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"product"},[_c('Header'),_c('ProductProfile'),_c('RelatedProducts'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }